/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {

    // Set mails flag unread to true
    createProject({ commit }, payload) {
      // commit("SET_ACTIVE_PROJECT_TITLE", payload.title)
      var projectInfo = {"title": payload.title, "workspace_id":payload.workspaceId, "detail": payload.detail}
      return new Promise((resolve, reject) => {
        axios.post("/api/project/create", projectInfo)
          .then((response) => {
            if(response.data.result == 'success') {
              commit("CREATE_PROJECT",response.data.projectInfo)
              commit("SET_ACTIVE_PROJECT", response.data.projectInfo)
              // router.push(router.currentRoute.query.to || '/pages/space/invite')
            }
            resolve(response)
          }).catch((error) => { reject(error) })
      })
    },
    updateProject({ commit }, payload){
      var projectInfo = {"title": payload.title, "id":payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/project/update", projectInfo)
          .then((response) => {
            if(response.data.result == 'success') {
              commit("UPDATE_PROJECT", payload)
              // router.push(router.currentRoute.query.to || '/pages/space/invite')
            }
            resolve(response)
          }).catch((error) => { reject(error) })
      })
    },
    inviteProject(context, payload) {
      var projectInfo = {"project_id": payload.projectId, "emails": payload.emails}
      return new Promise((resolve, reject) => {
        axios.post("/api/project/invite", projectInfo)
        .then((response) => {
          if(response.data.result == 'success'){
            // commit("SET_PROJECT_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    getProject({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/project/" + payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("SET_PROJECT_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    // getOneProject({ commit }, payload) {
    //   // var projectInfo = {"project_id": payload.project_Id}
    //   return new Promise((resolve, reject) => {
    //     axios.get("/api/workspace/project/" + payload)
    //     .then((response) => {
    //       if(response.data.result == 'success'){
    //         commit("SET_ACTIVE_PROJECT", response.data.data)
    //       }
    //       resolve(response)
    //     }).catch((error) => { reject(error) })
    //   })
    // },
    agreeInvite(context, payload){
      // var inviteInfo = {"workspace_id": payload.workspace_id, "invite_note_id": payload.id}
      return new Promise((resolve, reject) => {
        axios.post("/api/project/invite/agree", payload)
          .then((response) => {
            if(response.data.result == 'success'){

              // commit("ADD_WORKSPACE", response.data.data)
              resolve(response.data.data)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getWorkspaceProject({ commit }){
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace-project/all").then((response) => {
          if(response.data.result == 'success'){
            commit("SET_WORKSPACE_PROJECT_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error)=>{reject(error)})
      })
    },
    deleteProject ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/project/"+ payload)
          .then((response) => {
            commit('DELETE_PROJECT', payload)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

}
